import { makeStyles } from '@mui/styles';
import Accordion from 'apollo-react/components/Accordion';
import AccordionDetails from 'apollo-react/components/AccordionDetails';
import AccordionSummary from 'apollo-react/components/AccordionSummary';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import AdvancedSearchCriteria from './AdvancedSearchCriteria';
import { makeEnhancedSearchAdvanced } from '../../actions/SearchPageActions';
import { useTranslation } from '../../custom-hooks/useTranslation';
import { getUITA } from '../../utils/commonUtils';

const useStyles = makeStyles({
  accordion: {
    border: 'none',
  },
  accordionSummary: {
    border: 'none',
    backgroundColor: 'white',
    '&:hover': {
      border: 'none',
    },
  },
});

const AdvancedSearchPanel = ({ entityType, searchQuery }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { isAdvancedSearch } = useSelector((state) => state.searchPage);
  const translateString = useTranslation();

  const handleClick = () => {
    dispatch(makeEnhancedSearchAdvanced({ isAdvancedSearch: !isAdvancedSearch }));
  };

  return (
    <Accordion
      ui-ta={getUITA('Advanced Options accordion')}
      className={classes.accordion}
      expanded={isAdvancedSearch}
      onChange={handleClick}
      aria-label={translateString('Advanced Options')}
    >
      <AccordionSummary className={classes.accordionSummary}>
        {translateString('Advanced Options')}
      </AccordionSummary>
      <AccordionDetails>
        <AdvancedSearchCriteria
          open={isAdvancedSearch}
          currentEntityType={entityType}
          currentSearchQuery={searchQuery}
        />
      </AccordionDetails>
    </Accordion>
  );
};

export default AdvancedSearchPanel;
